import ConnexService from '@Api/connex';
import { fromJS } from 'immutable';

const prefix = 'connex';

const FETCH_TRANSFER_REQUEST = `${prefix}_FETCH_TRANSFER_REQUEST`;
const FETCH_TRANSFER_SUCCESS = `${prefix}_FETCH_TRANSFER_SUCCESS`;
const FETCH_TRANSFER_FAILURE = `${prefix}_FETCH_TRANSFER_FAILURE`;

// 获取历史数据
/**
 *
 * @param { _tokenId, offset, limit} parmas
 *
 */
const fetchTransferHistoryList = (parmas) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_TRANSFER_REQUEST });
    const response = await ConnexService.fetchTransferHistoryList(parmas);
    if (response) {
      dispatch({ type: FETCH_TRANSFER_SUCCESS, payload: fromJS(response) });
    }
  } catch (err) {
    dispatch({
      type: FETCH_TRANSFER_FAILURE,
      payload: err.message,
    });
  }
};

const TRANSFER_REQUEST = `${prefix}_TRANSFER_REQUEST`;
const TRANSFER_SUCCESS = `${prefix}_TRANSFER_SUCCESS`;
const TRANSFER_FAILURE = `${prefix}_TRANSFER_FAILURE`;

const transfer = (...rest) => async (dispatch) => {
  try {
    dispatch({ type: TRANSFER_REQUEST });
    const response = await ConnexService.transfer(...rest);
    if (response) {
      dispatch({ type: TRANSFER_SUCCESS, payload: fromJS(response) });
    }
  } catch (err) {
    dispatch({
      type: TRANSFER_FAILURE,
      payload: err.message,
    });
  }
};

const LOGIN_REQUEST = `${prefix}_LOGIN_REQUEST`;
const LOGIN_SUCCESS = `${prefix}_LOGIN_SUCCESS`;
const LOGIN_FAILURE = `${prefix}_LOGIN_FAILURE`;

const login = () => async (dispatch) => {
  try {
    dispatch({ type: LOGIN_REQUEST });
    const response = await ConnexService.login();
    if (response) {
      dispatch({ type: LOGIN_SUCCESS, payload: fromJS(response) });
      sessionStorage.userInfo = JSON.stringify(response);
      return true;
    }
    return false;
  } catch (err) {
    dispatch({
      type: LOGIN_FAILURE,
      payload: err.message,
    });
  }
  return false;
};

const FETCH_TOKENURI_REQUEST = `${prefix}_FETCH_TOKENURI_REQUEST`;
const FETCH_TOKENURI_SUCCESS = `${prefix}_FETCH_TOKENURI_SUCCESS`;
const FETCH_TOKENURI_FAILURE = `${prefix}_FETCH_TOKENURI_FAILURE`;

const tokenURI = (tokenId) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_TOKENURI_REQUEST });
    const response = await ConnexService.tokenURI(tokenId);
    if (response) {
      dispatch({ type: FETCH_TOKENURI_SUCCESS, payload: fromJS(response) });
    }
  } catch (err) {
    dispatch({
      type: FETCH_TOKENURI_FAILURE,
      payload: err.message,
    });
  }
};

const FETCH_OWNER_REQUEST = `${prefix}_FETCH_OWNER_REQUEST`;
const FETCH_OWNER_SUCCESS = `${prefix}_FETCH_OWNER_SUCCESS`;
const FETCH_OWNER_FAILURE = `${prefix}_FETCH_OWNER_FAILURE`;

const ownerOf = (tokenId) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_OWNER_REQUEST });
    const response = await ConnexService.ownerOf(tokenId);
    if (response) {
      dispatch({ type: FETCH_OWNER_SUCCESS, payload: response });
    }
  } catch (err) {
    dispatch({
      type: FETCH_OWNER_FAILURE,
      payload: err.message,
    });
  }
};

const SET_CACHE_USER = `${prefix}_SET_CACHE_USER`;

const setCacheUser = (data) => async (dispatch) => {
  dispatch({ type: SET_CACHE_USER, payload: fromJS(data) });
};

export default {
  FETCH_TRANSFER_REQUEST,
  FETCH_TRANSFER_SUCCESS,
  FETCH_TRANSFER_FAILURE,
  fetchTransferHistoryList,

  TRANSFER_REQUEST,
  TRANSFER_SUCCESS,
  TRANSFER_FAILURE,
  transfer,

  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  login,

  FETCH_TOKENURI_REQUEST,
  FETCH_TOKENURI_SUCCESS,
  FETCH_TOKENURI_FAILURE,
  tokenURI,

  FETCH_OWNER_REQUEST,
  FETCH_OWNER_SUCCESS,
  FETCH_OWNER_FAILURE,
  ownerOf,

  SET_CACHE_USER,
  setCacheUser,
};
